import SideMenuOcoOptions from './SideMenuOcoOptions';

export default SideMenuOcoOptions;
